import axios from "@/utils/axios";

export default {
  getTemplates(data) {
    return axios.get(`/collection/${data.id}/template`, { params: { page: data.page, page_size: data.page_size } });
  },

  reRunTemplateBatch(data) {
    return axios.put(`/template/${data.id}/batch-rerun/${data.batchId}`);
  },

  addTemplateBatch(data) {
    return axios.post(`/template/${data.id}/batch`, data.formData);
  },

  deleteTemplateBatch(data) {
    return axios.delete(
      `/template/${data.template_id}/batch-result/${data.template_batch_id}/item/${data.template_batch_item_id}`
    );
  },

  addNoteTemplateBatch(data) {
    let note = data.note;
    return axios.post(
      `/template/${data.template_id}/batch-result/${data.template_batch_id}/item/${data.template_batch_item_id}`,
      { note }
    );
  },

  getExportXlsx(data) {
    return axios.get(
      `/template/${data.id}/batch-result/${data.batchId}/export`
    );
  },

  createTemplate(data) {
    return axios.post("/template", data);
  },

  deleteTemplate(id) {
    return axios.delete(`/template/${id}`);
  },

  deleteBatch(data) {
    return axios.delete(
      `/template/${data.template_id}/batch-status/${data.template_batch_id}`
    );
  },

  deleteCollection(id) {
    return axios.delete(`/collection/${id}`);
  },

  getTemplate(id) {
    return axios.get(`/template/${id}`);
  },

  storeTemplateBox(data) {
    return axios.post(`/template/${data.id}/box`, data.boxes);
  },

  getTemplateResult(data) {
    return axios.get(
      `/template/${data.template_id}/batch-result/${data.template_batch_id}`
    );
  },

  confirmResult(data) {
    return axios.post(
      `/template/${data.template_id}/batch-result/${data.template_batch_id}`,
      data.items
    );
  },

  getBatchList(data) {
    return axios.get(`/template/${data.id}/batch-list`, { params: { page: data.page, page_size: data.page_size } });
  },

  getBatchResultCsv(data) {
    return axios.get(
      `/template/${data.template_id}/batch-result/${data.template_batch_id}/export-csv`
    );
  },

  saveTemplateAssignment(data) {
    let templateId = data.get("id");
    return axios.put(`/template/${templateId}`, data);
  },

  saveTemplateName(data) {
    let templateId = data.get("id");
    return axios.put(`/template/${templateId}`, data);
  },

  saveBatchName(data) {
    let templateId = data.get("template_id");
    let id = data.get("id");
    return axios.put(`/template/${templateId}/batch-status/${id}`, data);
  },

  searchTemplateName(data) {
    return axios.post(`/template/search`, data);
  },

  searchBatchName(data) {
    return axios.post(`/template-batch/search`, data);
  },

  exportXlsx(data) {
    return axios.get(`/template/${data.template_id}/batch-result/${data.batch_id}/export`);
  },

  exportXlsxCompress(data) {
    return axios.get(`/template/${data.template_id}/batch-result/${data.batch_id}/compress`);
  },


  getUser(data) {
    return axios.get(`/user/setting`, data);
  },

  updateSettingUser(data) {
    return axios.post(`/user/setting`, data);
  },
};
